var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deployment)?_c('div',{staticClass:"gp-content"},[_c('content-tab-bar',{attrs:{"tabs":_vm.tabs}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"deployment":_vm.deployment}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }